export const POUNDS_PER_KILOGRAM = 2.20462;
export const POUNDS_PER_STONE = 14;

export interface StonePoundsWeight {
  stones: number;
  pounds: number;
}

/**
 * Converts kilograms to the conventional UK whole stone and pounds display.
 * The total is rounded once so pounds is always in the range 0–13.
 */
export function kilogramsToStonePounds(kilograms: number): StonePoundsWeight {
  const totalPounds = Math.max(0, Math.round(kilograms * POUNDS_PER_KILOGRAM));
  return {
    stones: Math.floor(totalPounds / POUNDS_PER_STONE),
    pounds: totalPounds % POUNDS_PER_STONE,
  };
}

export function stonePoundsToKilograms(stones: number, pounds: number): number {
  return ((stones * POUNDS_PER_STONE) + pounds) / POUNDS_PER_KILOGRAM;
}
